(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-mb-flex"]) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });
  document.addEventListener('product-form:submit:success', () => {
    // Kein eigener Toast mehr: der Slide-Cart-Drawer öffnet sich und ist Bestätigung genug
    // (vermied die dunkle "Pille", die sich mit dem Cart-Drawer überlagerte). showMbToast bleibt für den Größen-Hinweis.
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  function showMbToast(text, kind) {
    var t = document.createElement('div');
    t.className = 'mb-toast mb-toast--' + (kind === 'warn' ? 'warn' : 'ok');
    t.textContent = text;
    t.style.animation = 'mb-toast ' + (kind === 'warn' ? '2.2s' : '1.8s') + ' ease forwards';
    document.body.appendChild(t);
    setTimeout(function(){ t.remove(); }, kind === 'warn' ? 2200 : 1800);
  }

  // Reviews link → smooth scroll to Judge.me widget (with fallbacks)
  document.addEventListener('click', function(e) {
    var link = e.target.closest('[data-mb-reviews-link]');
    if (!link) return;
    e.preventDefault();
    var t = document.getElementById('mb-reviews');
    if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Gift toggle: enable/disable the line-item-property textarea so empty gifts aren't submitted
  document.addEventListener('click', function(e) {
    var g = e.target.closest('[data-mb-gift]');
    if (!g) return;
    var on = g.classList.toggle('mb-gift--on');
    g.setAttribute('aria-pressed', on ? 'true' : 'false');
    var chk = g.querySelector('[data-mb-gift-check]');
    if (chk) chk.hidden = !on;
    var msg = document.querySelector('[data-mb-gift-msg]');
    if (msg) { msg.hidden = !on; msg.disabled = !on; if (on) msg.focus(); }
  });

  // Ist die Grußkarte ein eigenes Produkt (Schalter im Editor + Produkt aktiv),
  // wandert sie nach dem Kauf-Klick als zweite Position in den Warenkorb.
  // Ohne Variant-Id passiert nichts — dann bleibt die Karte kostenlos.
  document.addEventListener('product-form:submit:success', function () {
    var g = document.querySelector('[data-mb-gift]');
    if (!g || !g.classList.contains('mb-gift--on')) return;
    var variante = g.getAttribute('data-mb-gift-variant');
    if (!variante) return;
    var msg = document.querySelector('[data-mb-gift-msg]');
    var eigenschaften = {};
    if (msg && msg.value.trim()) eigenschaften['Grußnachricht'] = msg.value.trim();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variante), quantity: 1, properties: eigenschaften }] })
    }).then(function () {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    }).catch(function () {});
  });

  // Notes toggle (Wünsche/No-Gos): gleiche Logik wie Gift — leere Notiz wird nicht submittet
  document.addEventListener('click', function(e) {
    var n = e.target.closest('[data-mb-notes]');
    if (!n) return;
    var on = n.classList.toggle('mb-notes--on');
    n.setAttribute('aria-expanded', on ? 'true' : 'false');
    var msg = document.querySelector('[data-mb-notes-msg]');
    if (msg) { msg.hidden = !on; msg.disabled = !on; if (on) msg.focus(); }
  });

  // Konkretes Lieferdatum (Obergrenze 4 Werktage wie ueberall im Shop, Wochenende uebersprungen)
  (function setDeliveryDate() {
    var el = document.querySelector('[data-mb-delivery]');
    if (!el) return;
    var d = new Date(), added = 0;
    while (added < 4) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) added++; }
    var datum = d.toLocaleDateString('de-DE', { weekday: 'short', day: 'numeric', month: 'long' });
    el.textContent = 'Lieferung bis ' + datum;
    document.querySelectorAll('[data-mb-lieferdatum]').forEach(function (z) { z.textContent = datum; });
  })();

  // Live-Zusammenfassung im Entwurfsformat: Paketname, Teile/Warenwert, Größe,
  // Preis — aktualisiert bei jeder Auswahl und nach dem Hot-Reload.
  (function initMbSummary() {
    function update() {
      var el = document.querySelector('[data-mb-summary]');
      if (!el) return;
      var metaEl = document.querySelector('[data-mb-summary-meta]');
      var sizeEl = document.querySelector('[data-mb-summary-size]');
      var preisEl = document.querySelector('[data-mb-summary-price]');
      var pkg = document.querySelector('.mb-pdp__package-card-wrap input[type="radio"]:checked');
      var size = document.querySelector('.mb-sizes input[type="radio"]:checked');

      if (pkg) {
        var card = pkg.closest('.mb-pdp__package-card-wrap');
        var nameEl = card && card.querySelector('.mb-pdp__pkg-name');
        var valEl = card && card.querySelector('.mb-pkg__value');
        var subEl = card && card.querySelector('.mb-pkg__sub');
        var priceEl = card && card.querySelector('.mb-pdp__pkg-price');
        if (nameEl) el.textContent = nameEl.textContent.trim();
        if (metaEl) {
          var teile = subEl ? subEl.textContent.trim() : '';
          var wert = '';
          if (valEl) {
            var m = valEl.textContent.match(/(\d+)/);
            if (m) wert = 'min. ' + m[1] + ' € Warenwert';
          }
          metaEl.textContent = [teile, wert].filter(Boolean).join(' · ');
        }
        if (preisEl && priceEl) preisEl.textContent = priceEl.textContent.trim();
      }

      if (sizeEl) {
        sizeEl.textContent = size ? 'Größe ' + size.value : 'Größe noch wählen';
        sizeEl.classList.toggle('mb-summary__size--offen', !size);
      }
    }
    document.addEventListener('change', function(e) {
      if (e.target.closest && (e.target.closest('.mb-pdp__package-card-wrap') || e.target.closest('.mb-sizes'))) update();
    });
    update();
    var hr = document.querySelector('product-hot-reload');
    if (hr) new MutationObserver(update).observe(hr, { childList: true });
  })();

  // Bildzähler und Bildbeschriftung folgen der aktiven Galerie-Folie
  (function initMbGalerieKennzeichen() {
    const zaehler = document.querySelector('[data-mb-galcount]');
    const beschriftung = document.querySelector('[data-mb-galcap]');
    const wrap = document.querySelector('.mb-gallery');
    const galerie = document.querySelector('.mb-gallery media-gallery');
    if (!galerie || (!zaehler && !beschriftung)) return;

    // Zuordnung "Suchbegriff | Beschriftung" aus dem Setting (je Zeile eine).
    // Der Suchbegriff wird gegen Dateiname UND Alt-Text geprüft.
    const zuordnung = ((wrap && wrap.dataset.mbCaptions) || '').split('\n')
      .map((z) => z.split('|'))
      .filter((t) => t.length >= 2 && t[0].trim())
      .map((t) => ({ suche: t[0].trim().toLowerCase(), text: t.slice(1).join('|').trim() }));
    const titelWorte = new Set(((wrap && wrap.dataset.mbTitel) || '').toLowerCase().split(/\s+/));

    // Ohne Zuordnung: Alt-Text um die Worte des Produkttitels kürzen —
    // "Mystery Box Vintage Box Nike Jacke" wird zu "Nike Jacke".
    const kuerzen = (alt) => {
      let worte = alt.split(/\s+/);
      while (worte.length > 2 && titelWorte.has(worte[0].toLowerCase().replace(/[^\wäöüß-]/gi, ''))) worte.shift();
      let rest = worte.join(' ').replace(/^[–—-]\s*/, '').trim();
      if (rest.length > 46) {
        const schnitt = rest.slice(0, 46).lastIndexOf(' ');
        rest = rest.slice(0, schnitt > 20 ? schnitt : 46).replace(/[,:;]$/, '') + '…';
      }
      return rest;
    };

    const label = (bild) => {
      const alt = (bild.getAttribute('alt') || '').trim();
      const quelle = ((bild.getAttribute('src') || '') + ' ' + alt).toLowerCase();
      const treffer = zuordnung.find((z) => quelle.includes(z.suche));
      if (treffer) return treffer.text;
      return alt ? kuerzen(alt) : '';
    };

    const aktualisieren = () => {
      const folien = [...galerie.querySelectorAll('.media-gallery__slide')];
      const idx = folien.findIndex((f) => f.classList.contains('media-gallery__slide--active'));
      if (idx < 0) return;
      if (zaehler) zaehler.textContent = (idx + 1) + ' / ' + folien.length;
      if (beschriftung) {
        const bild = folien[idx].querySelector('img');
        const text = bild ? label(bild) : '';
        beschriftung.textContent = text;
        beschriftung.style.display = text ? '' : 'none';
      }
    };
    new MutationObserver(aktualisieren).observe(galerie, {
      subtree: true, attributes: true, attributeFilter: ['class']
    });
    aktualisieren();
  })();

  // H1 einzeilig wie im Entwurf: Schrift schrittweise verkleinern, bis der
  // Titel in eine Zeile passt (Untergrenze 19px — laengere Live-Titel wie
  // "Mystery Box Vintage Kleidung" brachen sonst um; der Entwurfs-Titel ist kuerzer)
  (function initTitelEinzeilig() {
    function fit() {
      var h = document.querySelector('.mb-title');
      if (!h) return;
      h.style.fontSize = '';
      var fs = parseFloat(getComputedStyle(h).fontSize);
      var lh, guard = 0;
      do {
        lh = parseFloat(getComputedStyle(h).lineHeight);
        if (h.scrollHeight <= lh * 1.5 || fs <= 19) break;
        fs -= 1;
        h.style.fontSize = fs + 'px';
        guard++;
      } while (guard < 10);
    }
    fit();
    window.addEventListener('resize', fit, { passive: true });
    var hrEl = document.querySelector('product-hot-reload');
    if (hrEl) new MutationObserver(fit).observe(hrEl, { childList: true });
  })();

  // Lupe öffnet die vorhandene Lightbox der aktiven Folie (kein eigener Betrachter)
  (function initMbZoom() {
    document.addEventListener('click', function (e) {
      const knopf = e.target.closest && e.target.closest('[data-mb-galzoom]');
      if (!knopf) return;
      const aktiv = document.querySelector('.mb-gallery .media-gallery__slide--active');
      const ausloeser = aktiv && aktiv.querySelector('.overlay-lightbox__trigger');
      if (ausloeser) ausloeser.click();
    });
  })();

  // Abschluss-CTA: klickt den Haupt-Knopf, damit Größenprüfung und Sheet greifen
  (function initPeakCta() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-mb-peak-btn]');
      if (!btn) return;
      var haupt = document.querySelector('.mb-pdp__atc-btn');
      if (haupt) haupt.click();
    });
    function peakAktualisieren() {
      var meta = document.querySelector('[data-mb-peak-meta]');
      var preis = document.querySelector('[data-mb-peak-price]');
      var pkg = document.querySelector('[data-mb-summary]');
      var pkgMeta = document.querySelector('[data-mb-summary-meta]');
      var pkgPreis = document.querySelector('[data-mb-summary-price]');
      if (meta && pkg) {
        var paket = pkg.textContent.trim();
        var teile = pkgMeta ? pkgMeta.textContent.trim() : '';
        // Der Paketname traegt die Teilezahl oft schon in Klammern — dann nicht doppeln
        if (teile && paket.toLowerCase().indexOf(teile.toLowerCase()) !== -1) teile = '';
        meta.textContent = [paket, teile].filter(Boolean).join(' · ');
      }
      if (preis && pkgPreis) preis.textContent = pkgPreis.textContent.trim();
    }
    document.addEventListener('change', function (e) {
      if (e.target.closest && (e.target.closest('.mb-pdp__package-card-wrap') || e.target.closest('.mb-sizes'))) {
        requestAnimationFrame(peakAktualisieren);
      }
    });
    var hr = document.querySelector('product-hot-reload');
    if (hr) new MutationObserver(peakAktualisieren).observe(hr, { childList: true });
  })();

  // Fit-guide sheet open/close
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-mb-open-guide]')) {
      var bd = document.querySelector('[data-mb-guide-backdrop]');
      if (bd) { bd.hidden = false; document.body.style.overflow = 'hidden'; }
    }
    if (e.target.closest('[data-mb-close-guide]') || e.target.hasAttribute('data-mb-guide-backdrop')) {
      var bd2 = document.querySelector('[data-mb-guide-backdrop]');
      if (bd2) { bd2.hidden = true; document.body.style.overflow = ''; }
    }
  });

  // FAQ accordion (single-open: opening one closes the others)
  document.addEventListener('click', function(e) {
    var q = e.target.closest('.mb-faq-q');
    if (!q) return;
    var wasOpen = q.getAttribute('aria-expanded') === 'true';
    var card = q.closest('.mb-faq-card');
    if (card) {
      card.querySelectorAll('.mb-faq-q[aria-expanded="true"]').forEach(function(o) {
        o.setAttribute('aria-expanded', 'false');
        var oa = o.parentNode.querySelector('.mb-faq-a');
        if (oa) oa.hidden = true;
      });
    }
    if (!wasOpen) {
      q.setAttribute('aria-expanded', 'true');
      var a = q.parentNode.querySelector('.mb-faq-a');
      if (a) a.hidden = false;
    }
  });

  // Reviews: Klick auf Verteilungs-Balken filtert die Cards nach Sternen
  document.addEventListener('click', function(e) {
    var clear = e.target.closest('[data-mb-rev-clear]');
    var bar = e.target.closest('[data-mb-rev-filter]');
    if (!clear && !bar) return;
    var cards = document.querySelectorAll('#mb-rev-cards [data-mb-rev-rating]');
    var hint = document.querySelector('[data-mb-rev-hint]');
    var bars = document.querySelectorAll('[data-mb-rev-filter]');
    function showAll() {
      cards.forEach(function(c) { c.style.display = ''; });
      bars.forEach(function(x) { x.classList.remove('active'); });
      if (hint) hint.hidden = true;
    }
    if (clear) { showAll(); return; }
    if (bar.disabled) return;
    if (bar.classList.contains('active')) { showAll(); return; }
    var rating = bar.getAttribute('data-mb-rev-filter');
    bars.forEach(function(x) { x.classList.remove('active'); });
    bar.classList.add('active');
    cards.forEach(function(c) { c.style.display = (c.getAttribute('data-mb-rev-rating') === rating) ? '' : 'none'; });
    if (hint) hint.hidden = false;
  });

  // Größe nie automatisch vorwählen: nach Paket-Wechsel setzt Shopify per Hot-Reload sonst die kleinste Größe.
  (function initSizeNoAutoSelect() {
    var lastWasSizeClick = false;
    document.addEventListener('change', function(e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('.mb-sizes')) lastWasSizeClick = true;
      else if (t.closest('.mb-pdp__package-card-wrap')) lastWasSizeClick = false;
    }, true);
    var hr = document.querySelector('product-hot-reload');
    if (hr) {
      new MutationObserver(function() {
        if (lastWasSizeClick) return;
        var c = document.querySelector('.mb-sizes input[type="radio"]:checked');
        if (c) c.checked = false;
      }).observe(hr, { childList: true });
    }
  })();

  // Re-clicking the already-selected package still swaps the gallery. The gallery starts on the
  // hero (media position 1), while the buy box pre-selects the bestseller package. A plain click on
  // an already-checked radio fires no 'change', so product-hot-reload never re-renders and the
  // gallery would stay on the hero. We capture the checked state on pointerdown (before the browser
  // settles the radio); if the same package was already selected, we dispatch a synthetic bubbling
  // 'change' to re-trigger the existing hot-reload, which re-renders the gallery to that variant's
  // image (option_values sets product.selected_variant). Delegated on document so it survives the swap.
  (function initPackageReclickGallery() {
    var downWrap = null, downWasChecked = false;
    document.addEventListener('pointerdown', function(e) {
      downWrap = e.target.closest ? e.target.closest('.mb-pdp__package-card-wrap') : null;
      var input = downWrap && downWrap.querySelector('input[type="radio"]');
      downWasChecked = !!(input && input.checked);
    }, true);
    document.addEventListener('click', function(e) {
      var wrap = e.target.closest ? e.target.closest('.mb-pdp__package-card-wrap') : null;
      if (!wrap || wrap !== downWrap || !downWasChecked) return;
      var input = wrap.querySelector('input[type="radio"]');
      if (input && input.checked) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  })();

  // Größen-Pflicht: ATC blockieren bis Größe bewusst gewählt (failt offen)
  (function initSizeGuard() {
    function sizeGroup() { return document.querySelector('.mb-sizes'); }
    function needsSize() {
      var g = sizeGroup();
      return g && g.querySelector('input[type="radio"]') && !g.querySelector('input[type="radio"]:checked');
    }
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.mb-pdp__atc-btn')) return;
      if (window.__mbBypassGuard) { window.__mbBypassGuard = false; return; }
      if (!needsSize()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (window.__mbOpenSizeSheet) { window.__mbOpenSizeSheet(); return; }
      var g = sizeGroup();
      g.classList.add('mb-pdp__option-group--error');
      if (!document.getElementById('mb-size-hint')) {
        var hint = document.createElement('p');
        hint.id = 'mb-size-hint';
        hint.className = 'mb-size-hint';
        hint.textContent = '⚠ Bitte wähle zuerst deine Größe';
        g.parentNode.insertBefore(hint, g.nextSibling);
      }
      showMbToast('⚠ Bitte wähle zuerst deine Größe', 'warn');
      g.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);
    document.addEventListener('change', function(e) {
      if (!e.target.closest('.mb-sizes')) return;
      var g = sizeGroup();
      if (g) g.classList.remove('mb-pdp__option-group--error');
      var hint = document.getElementById('mb-size-hint');
      if (hint) hint.remove();
    });
  })();

  // Box-&-Größe-Sheet: öffnet bei ATC ohne Größe; legt direkt in den Warenkorb (variant-id aus Map, ohne hot-reload-Wartezeit)
  (function initSizeSheet() {
    var backdrop = document.querySelector('[data-mb-size-backdrop]');
    if (!backdrop) return;
    var pendingReload = false, onReloadDone = null, sheetSelectedSize = null;
    function realChecked() {
      var g = document.querySelector('.mb-sizes');
      return g ? g.querySelector('input[type="radio"]:checked') : null;
    }
    function sync() {
      var checked = realChecked();
      var val = checked ? checked.value : sheetSelectedSize;
      backdrop.querySelectorAll('[data-mb-sheet-size]').forEach(function(b) {
        b.classList.toggle('mb-size-btn--active', !!val && b.getAttribute('data-mb-sheet-size') === val);
      });
      var c = backdrop.querySelector('[data-mb-sheet-confirm]');
      if (c) { c.disabled = !val; c.textContent = val ? 'In den Warenkorb' : 'Größe wählen'; }
    }
    function close() { backdrop.hidden = true; document.body.style.overflow = ''; }
    window.__mbOpenSizeSheet = function() { backdrop.hidden = false; document.body.style.overflow = 'hidden'; sync(); };
    var hr = document.querySelector('product-hot-reload');
    if (hr) new MutationObserver(function() {
      pendingReload = false;
      if (!backdrop.hidden) sync();
      if (onReloadDone) { var cb = onReloadDone; onReloadDone = null; cb(); }
    }).observe(hr, { childList: true });
    backdrop.addEventListener('click', function(e) {
      var sb = e.target.closest('[data-mb-sheet-size]');
      if (sb && !sb.disabled) {
        var val = sb.getAttribute('data-mb-sheet-size');
        sheetSelectedSize = val;
        var g = document.querySelector('.mb-sizes');
        var radio = null;
        if (g) g.querySelectorAll('input[type="radio"]').forEach(function(r) { if (r.value === val) radio = r; });
        if (radio) { pendingReload = true; radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        backdrop.querySelectorAll('[data-mb-sheet-size]').forEach(function(b) { b.classList.toggle('mb-size-btn--active', b === sb); });
        var c = backdrop.querySelector('[data-mb-sheet-confirm]');
        if (c) { c.disabled = false; c.textContent = 'In den Warenkorb'; }
        return;
      }
      if (e.target.closest('[data-mb-sheet-confirm]')) {
        if (!sheetSelectedSize) return;
        var pkg = document.querySelector('.mb-pdp__package-card-wrap input[type="radio"]:checked');
        var vid = (window.mbVariantMap || {})[(pkg ? pkg.value : '') + '|' + sheetSelectedSize];
        var idInput = document.querySelector('[name="id"]');
        var fire = function() { window.__mbBypassGuard = true; close(); var atc = document.querySelector('.mb-pdp__atc-btn'); if (atc) atc.click(); };
        if (vid && idInput) { idInput.value = vid; fire(); }                                  // Schnellweg: kein Warten
        else if (pendingReload) { onReloadDone = fire; setTimeout(function() { if (onReloadDone) { onReloadDone = null; fire(); } }, 600); }  // Fallback
        else fire();
        return;
      }
      if (e.target.closest('[data-mb-close-size]') || e.target.hasAttribute('data-mb-size-backdrop')) { close(); }
    });
  })();

  // Hot-reload: hold the block's height so the layout (and sticky header) never shifts during the swap.
  // No min-height reset -> no scroll jump -> theme's scroll-driven header stays put.
  (function initHotReloadStabilizer() {
    const hr = document.querySelector('product-hot-reload');
    if (!hr) return;
    var lock = function() { hr.style.minHeight = hr.scrollHeight + 'px'; };
    lock();
    new MutationObserver(function() { requestAnimationFrame(lock); }).observe(hr, { childList: true });
  })();

  // Sticky CTA: appears after main CTA scrolled above viewport; hides at footer
  (function initStickyATC() {
    const stickyEl = document.getElementById('mb-sticky-atc');
    if (!stickyEl) return;
    // Ueber die Scrollposition statt ueber einen IntersectionObserver: der
    // Kauf-Knopf liegt auf schmalen Bildschirmen von Anfang an unterhalb des
    // Sichtfelds und wird nie sichtbar — der Observer feuerte dann kein
    // einziges Mal, die Leiste blieb aus (gemessen 31.07., gleicher Befund
    // wie auf der Artikelseite).
    let angefordert = false;
    const footer = document.querySelector('footer, .footer, .site-footer, [role="contentinfo"]');
    function findMainATC() { return document.querySelector('.mb-pdp__atc-btn'); }
    function update() {
      angefordert = false;
      const b = findMainATC();
      if (!b) return;
      const vorbei = b.getBoundingClientRect().bottom < 0;
      let footerImBild = false;
      if (footer) {
        const fr = footer.getBoundingClientRect();
        footerImBild = fr.top < (window.innerHeight || 0) && fr.bottom > 0;
      }
      const show = vorbei && !footerImBild;
      stickyEl.classList.toggle('mb-pdp__sticky-atc--visible', show);
      stickyEl.setAttribute('aria-hidden', !show);
      stickyEl.inert = !show;
      document.body.classList.toggle('mb-sticky-active', show);
    }
    function anstossen() {
      if (angefordert) return;
      angefordert = true;
      requestAnimationFrame(update);
    }
    function observeATC() { anstossen(); return null; }
    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', anstossen, { passive: true });
    function updateContent() {
      // Mock-Format: Preis gross, darunter "Paket · Groesse waehlen" bzw. "Paket · Gr. X"
      const titleEl = stickyEl.querySelector('[data-sticky-title]');
      const subEl = stickyEl.querySelector('[data-sticky-sub]');
      const btn = stickyEl.querySelector('[data-sticky-btn]');
      if (!titleEl || !btn) return;
      const checked = document.querySelector('.mb-pdp__package-card-wrap input[type="radio"]:checked');
      const size = document.querySelector('.mb-sizes input[type="radio"]:checked');
      let name = '', price = '';
      if (checked) {
        const card = checked.closest('.mb-pdp__package-card-wrap');
        const nameEl = card && card.querySelector('.mb-pdp__pkg-name');
        const priceEl = card && card.querySelector('.mb-pdp__pkg-price');
        if (nameEl) name = nameEl.textContent.trim();
        if (priceEl) price = priceEl.textContent.trim();
      }
      if (price) titleEl.textContent = price;
      if (subEl && name) subEl.textContent = name + (size ? ' · Gr. ' + size.value : ' · Größe wählen');
      const main = findMainATC();
      if (main) { btn.disabled = main.disabled; btn.textContent = main.disabled ? 'Ausverkauft' : 'Warenkorb'; }
    }
    stickyEl.addEventListener('click', (e) => {
      if (e.target.closest('[data-sticky-btn]')) {
        const m = findMainATC();
        if (m) m.click();
      }
    });
    requestAnimationFrame(() => {
      let obs = observeATC();
      updateContent();
      const hr = document.querySelector('product-hot-reload');
      if (hr) new MutationObserver(() => { if (obs) obs.disconnect(); obs = observeATC(); updateContent(); }).observe(hr, { childList: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-mystery-box"]) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });
  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    showMbToast('✓ Zur Box hinzugefügt', 'ok');
  });

  function showMbToast(text, kind) {
    var t = document.createElement('div');
    t.className = 'mb-toast mb-toast--' + (kind === 'warn' ? 'warn' : 'ok');
    t.textContent = text;
    t.style.animation = 'mb-toast ' + (kind === 'warn' ? '2.2s' : '1.8s') + ' ease forwards';
    document.body.appendChild(t);
    setTimeout(function(){ t.remove(); }, kind === 'warn' ? 2200 : 1800);
  }

  // Reviews link → smooth scroll to Judge.me widget (with fallbacks)
  document.addEventListener('click', function(e) {
    var link = e.target.closest('[data-mb-reviews-link]');
    if (!link) return;
    e.preventDefault();
    var t = document.getElementById('mb-reviews');
    if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Gift toggle: enable/disable the line-item-property textarea so empty gifts aren't submitted
  document.addEventListener('click', function(e) {
    var g = e.target.closest('[data-mb-gift]');
    if (!g) return;
    var on = g.classList.toggle('mb-gift--on');
    g.setAttribute('aria-pressed', on ? 'true' : 'false');
    var chk = g.querySelector('[data-mb-gift-check]');
    if (chk) chk.hidden = !on;
    var msg = document.querySelector('[data-mb-gift-msg]');
    if (msg) { msg.hidden = !on; msg.disabled = !on; if (on) msg.focus(); }
  });

  // Fit-guide sheet open/close
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-mb-open-guide]')) {
      var bd = document.querySelector('[data-mb-guide-backdrop]');
      if (bd) { bd.hidden = false; document.body.style.overflow = 'hidden'; }
    }
    if (e.target.closest('[data-mb-close-guide]') || e.target.hasAttribute('data-mb-guide-backdrop')) {
      var bd2 = document.querySelector('[data-mb-guide-backdrop]');
      if (bd2) { bd2.hidden = true; document.body.style.overflow = ''; }
    }
  });

  // FAQ accordion (single-open: opening one closes the others)
  document.addEventListener('click', function(e) {
    var q = e.target.closest('.mb-faq-q');
    if (!q) return;
    var wasOpen = q.getAttribute('aria-expanded') === 'true';
    var card = q.closest('.mb-faq-card');
    if (card) {
      card.querySelectorAll('.mb-faq-q[aria-expanded="true"]').forEach(function(o) {
        o.setAttribute('aria-expanded', 'false');
        var oa = o.parentNode.querySelector('.mb-faq-a');
        if (oa) oa.hidden = true;
      });
    }
    if (!wasOpen) {
      q.setAttribute('aria-expanded', 'true');
      var a = q.parentNode.querySelector('.mb-faq-a');
      if (a) a.hidden = false;
    }
  });

  // Reviews: Klick auf Verteilungs-Balken filtert die Cards nach Sternen
  document.addEventListener('click', function(e) {
    var clear = e.target.closest('[data-mb-rev-clear]');
    var bar = e.target.closest('[data-mb-rev-filter]');
    if (!clear && !bar) return;
    var cards = document.querySelectorAll('#mb-rev-cards [data-mb-rev-rating]');
    var hint = document.querySelector('[data-mb-rev-hint]');
    var bars = document.querySelectorAll('[data-mb-rev-filter]');
    function showAll() {
      cards.forEach(function(c) { c.style.display = ''; });
      bars.forEach(function(x) { x.classList.remove('active'); });
      if (hint) hint.hidden = true;
    }
    if (clear) { showAll(); return; }
    if (bar.disabled) return;
    if (bar.classList.contains('active')) { showAll(); return; }
    var rating = bar.getAttribute('data-mb-rev-filter');
    bars.forEach(function(x) { x.classList.remove('active'); });
    bar.classList.add('active');
    cards.forEach(function(c) { c.style.display = (c.getAttribute('data-mb-rev-rating') === rating) ? '' : 'none'; });
    if (hint) hint.hidden = false;
  });

  // Größe nie automatisch vorwählen: nach Paket-Wechsel setzt Shopify per Hot-Reload sonst die kleinste Größe.
  (function initSizeNoAutoSelect() {
    var lastWasSizeClick = false;
    document.addEventListener('change', function(e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('.mb-sizes')) lastWasSizeClick = true;
      else if (t.closest('.mb-pdp__package-card-wrap')) lastWasSizeClick = false;
    }, true);
    var hr = document.querySelector('product-hot-reload');
    if (hr) {
      new MutationObserver(function() {
        if (lastWasSizeClick) return;
        var c = document.querySelector('.mb-sizes input[type="radio"]:checked');
        if (c) c.checked = false;
      }).observe(hr, { childList: true });
    }
  })();

  // Größen-Pflicht: ATC blockieren bis Größe bewusst gewählt (failt offen)
  (function initSizeGuard() {
    function sizeGroup() { return document.querySelector('.mb-sizes'); }
    function needsSize() {
      var g = sizeGroup();
      return g && g.querySelector('input[type="radio"]') && !g.querySelector('input[type="radio"]:checked');
    }
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.mb-pdp__atc-btn')) return;
      if (!needsSize()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (window.__mbOpenSizeSheet) { window.__mbOpenSizeSheet(); return; }
      var g = sizeGroup();
      g.classList.add('mb-pdp__option-group--error');
      if (!document.getElementById('mb-size-hint')) {
        var hint = document.createElement('p');
        hint.id = 'mb-size-hint';
        hint.className = 'mb-size-hint';
        hint.textContent = '⚠ Bitte wähle zuerst deine Größe';
        g.parentNode.insertBefore(hint, g.nextSibling);
      }
      showMbToast('⚠ Bitte wähle zuerst deine Größe', 'warn');
      g.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);
    document.addEventListener('change', function(e) {
      if (!e.target.closest('.mb-sizes')) return;
      var g = sizeGroup();
      if (g) g.classList.remove('mb-pdp__option-group--error');
      var hint = document.getElementById('mb-size-hint');
      if (hint) hint.remove();
    });
  })();

  // Box-&-Größe-Sheet: öffnet bei ATC ohne Größe; wartet auf hot-reload, bevor es in den Warenkorb legt
  (function initSizeSheet() {
    var backdrop = document.querySelector('[data-mb-size-backdrop]');
    if (!backdrop) return;
    var pendingReload = false, onReloadDone = null;
    function realChecked() {
      var g = document.querySelector('.mb-sizes');
      return g ? g.querySelector('input[type="radio"]:checked') : null;
    }
    function sync() {
      var checked = realChecked();
      var val = checked ? checked.value : null;
      backdrop.querySelectorAll('[data-mb-sheet-size]').forEach(function(b) {
        b.classList.toggle('mb-size-btn--active', !!val && b.getAttribute('data-mb-sheet-size') === val);
      });
      var c = backdrop.querySelector('[data-mb-sheet-confirm]');
      if (c) { c.disabled = !val; c.textContent = val ? 'In den Warenkorb' : 'Größe wählen'; }
    }
    function close() { backdrop.hidden = true; document.body.style.overflow = ''; }
    window.__mbOpenSizeSheet = function() { backdrop.hidden = false; document.body.style.overflow = 'hidden'; sync(); };
    var hr = document.querySelector('product-hot-reload');
    if (hr) new MutationObserver(function() {
      pendingReload = false;
      if (!backdrop.hidden) sync();
      if (onReloadDone) { var cb = onReloadDone; onReloadDone = null; cb(); }
    }).observe(hr, { childList: true });
    backdrop.addEventListener('click', function(e) {
      var sb = e.target.closest('[data-mb-sheet-size]');
      if (sb && !sb.disabled) {
        var val = sb.getAttribute('data-mb-sheet-size');
        var g = document.querySelector('.mb-sizes');
        var radio = null;
        if (g) g.querySelectorAll('input[type="radio"]').forEach(function(r) { if (r.value === val) radio = r; });
        if (radio) { pendingReload = true; radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        backdrop.querySelectorAll('[data-mb-sheet-size]').forEach(function(b) { b.classList.toggle('mb-size-btn--active', b === sb); });
        var c = backdrop.querySelector('[data-mb-sheet-confirm]');
        if (c) { c.disabled = false; c.textContent = 'In den Warenkorb'; }
        return;
      }
      if (e.target.closest('[data-mb-sheet-confirm]')) {
        if (!realChecked()) return;
        var add = function() { close(); var atc = document.querySelector('.mb-pdp__atc-btn'); if (atc) atc.click(); };
        if (pendingReload) { onReloadDone = add; setTimeout(function() { if (onReloadDone) { onReloadDone = null; add(); } }, 900); }
        else add();
        return;
      }
      if (e.target.closest('[data-mb-close-size]') || e.target.hasAttribute('data-mb-size-backdrop')) { close(); }
    });
  })();

  // Hot-reload: hold the block's height so the layout (and sticky header) never shifts during the swap.
  // No min-height reset -> no scroll jump -> theme's scroll-driven header stays put.
  (function initHotReloadStabilizer() {
    const hr = document.querySelector('product-hot-reload');
    if (!hr) return;
    var lock = function() { hr.style.minHeight = hr.scrollHeight + 'px'; };
    lock();
    new MutationObserver(function() { requestAnimationFrame(lock); }).observe(hr, { childList: true });
  })();

  // Sticky CTA: appears after main CTA scrolled above viewport; hides at footer
  (function initStickyATC() {
    const stickyEl = document.getElementById('mb-sticky-atc');
    if (!stickyEl) return;
    let atcHidden = false, footerVisible = false;
    function findMainATC() { return document.querySelector('.mb-pdp__atc-btn'); }
    function update() {
      const show = atcHidden && !footerVisible;
      stickyEl.classList.toggle('mb-pdp__sticky-atc--visible', show);
      stickyEl.setAttribute('aria-hidden', !show);
      stickyEl.inert = !show;
      document.body.classList.toggle('mb-sticky-active', show);
    }
    function observeATC() {
      const b = findMainATC();
      if (!b) return null;
      const o = new IntersectionObserver(([en]) => {
        atcHidden = !en.isIntersecting && en.boundingClientRect.top < 0;
        update();
      }, { threshold: 0 });
      o.observe(b);
      return o;
    }
    const footer = document.querySelector('footer, .footer, .site-footer, [role="contentinfo"]');
    if (footer) new IntersectionObserver(([en]) => { footerVisible = en.isIntersecting; update(); }, { threshold: 0 }).observe(footer);
    function updateContent() {
      const titleEl = stickyEl.querySelector('[data-sticky-title]');
      const btn = stickyEl.querySelector('[data-sticky-btn]');
      if (!titleEl || !btn) return;
      const checked = document.querySelector('.mb-pdp__package-card-wrap input[type="radio"]:checked');
      let name = '', price = '';
      if (checked) {
        const card = checked.closest('.mb-pdp__package-card-wrap');
        const nameEl = card && card.querySelector('.mb-pdp__pkg-name');
        const priceEl = card && card.querySelector('.mb-pdp__pkg-price');
        if (nameEl) name = nameEl.textContent.trim();
        if (priceEl) price = priceEl.textContent.trim();
      }
      titleEl.textContent = name ? name + ' · ' + price : price;
      const main = findMainATC();
      if (main) { btn.disabled = main.disabled; btn.textContent = main.textContent.trim(); }
    }
    stickyEl.addEventListener('click', (e) => {
      if (e.target.closest('[data-sticky-btn]')) {
        const m = findMainATC();
        if (m) m.click();
      }
    });
    requestAnimationFrame(() => {
      let obs = observeATC();
      updateContent();
      const hr = document.querySelector('product-hot-reload');
      if (hr) new MutationObserver(() => { if (obs) obs.disconnect(); obs = observeATC(); updateContent(); }).observe(hr, { childList: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-vintage"]) return;
  try {
    
  // Warenkorb-Schublade statt Seitenwechsel
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  // Akkordeons + Details-Aufklapper (ausverkauft)
  document.addEventListener('click', (event) => {
    const header = event.target.closest('.vp-pdp__accordion-header, .vp-pdp__details-toggle');
    if (!header) return;
    const expanded = header.getAttribute('aria-expanded') === 'true';
    header.setAttribute('aria-expanded', !expanded);
    const body = document.getElementById(header.getAttribute('aria-controls'));
    if (!body) return;
    if (header.classList.contains('vp-pdp__details-toggle')) {
      body.setAttribute('data-collapsed', expanded ? 'true' : 'false');
    } else {
      body.setAttribute('aria-hidden', expanded);
    }
  });

  // Bildzaehler der Galerie
  (function initGalleryCounter() {
    const zaehler = document.querySelector('[data-vp-galcount]');
    const galerie = document.querySelector('.vp-pdp__gallery media-gallery');
    if (!zaehler || !galerie) return;
    const slides = () => [...galerie.querySelectorAll('.media-gallery__slide')];
    const update = () => {
      const alle = slides();
      const idx = alle.findIndex((s) => s.classList.contains('media-gallery__slide--active'));
      if (idx >= 0) zaehler.textContent = (idx + 1) + ' / ' + alle.length;
    };
    new MutationObserver(update).observe(galerie, {
      subtree: true, attributes: true, attributeFilter: ['class']
    });
    update();
  })();

  // Audit Phase 3, P5 Nachtrag (Entscheid Flori 28.09.2026 "Rahmen fuellen"): Fotos im Hochformat 3:4 (1125x1500,
  // 43 % der Bilder verfuegbarer Unikate) liessen im 4:5-Rahmen links und rechts je rund 12 px frei. Sie fuellen ihn jetzt
  // (object-fit: cover, oben und unten fallen je rund 3 % weg). Querformat und 4:5 bleiben contain, damit nichts
  // Wichtiges abgeschnitten wird. Verhaeltnis aus width/height des img (sofort da, auch bei loading=lazy).
  (function initBildFuellen() {
    document.querySelectorAll('.vp-pdp__gallery .media-gallery__main img').forEach(function (img) {
      const w = +img.getAttribute('width');
      const h = +img.getAttribute('height');
      if (!w || !h) return;
      const r = w / h;
      if (r >= 0.70 && r < 0.795) img.classList.add('btc-bild-fuellt');
    });
  })();

  // Hot-Reload: Hoehe und Scrollposition beim Variantenwechsel halten
  (function initHotReloadStabilizer() {
    const hr = document.querySelector('.vp-pdp-section product-hot-reload');
    if (!hr) return;
    let savedScrollY = 0;
    hr.addEventListener('change', function (e) {
      if (e.target.hasAttribute('data-product-hot-reload-trigger')) {
        savedScrollY = window.scrollY;
        this.style.minHeight = this.offsetHeight + 'px';
      }
    });
    const observer = new MutationObserver(() => {
      window.scrollTo(0, savedScrollY);
      requestAnimationFrame(() => {
        hr.style.minHeight = '';
        window.scrollTo(0, savedScrollY);
      });
    });
    observer.observe(hr, { childList: true });
  })();

  // Sticky-Kaufleiste: erscheint, sobald der Haupt-Knopf nach oben aus dem Bild
  // gescrollt ist. Bewusst ueber die Scrollposition statt ueber einen
  // IntersectionObserver: auf schmalen Bildschirmen liegt der Knopf beim Laden
  // schon unterhalb des Sichtfelds und wird nie "sichtbar" — der Observer feuert
  // dann kein einziges Mal (gemessen 31.07.: Leiste blieb dauerhaft aus).
  (function initStickyATC() {
    const stickyEl = document.getElementById('vp-sticky-atc');
    if (!stickyEl) return;
    const footer = document.querySelector('footer, .footer, .site-footer, [role="contentinfo"]');
    const mainBtn = () => document.querySelector('.vp-pdp__atc-btn');
    let angefordert = false;

    function pruefen() {
      angefordert = false;
      const btn = mainBtn();
      if (!btn) return;
      const vorbei = btn.getBoundingClientRect().bottom < 0;
      let footerImBild = false;
      if (footer) {
        const fr = footer.getBoundingClientRect();
        footerImBild = fr.top < (window.innerHeight || 0) && fr.bottom > 0;
      }
      const zeigen = vorbei && !footerImBild;
      stickyEl.classList.toggle('vp-pdp__sticky-atc--visible', zeigen);
      stickyEl.setAttribute('aria-hidden', !zeigen);
      stickyEl.inert = !zeigen;
      document.body.classList.toggle('vp-sticky-active', zeigen);
    }

    function anstossen() {
      if (angefordert) return;
      angefordert = true;
      requestAnimationFrame(pruefen);
    }

    function preisUebernehmen() {
      const ziel = stickyEl.querySelector('[data-sticky-price]');
      const quelle = document.querySelector('.vp-pdp__price');
      if (ziel && quelle) ziel.innerHTML = quelle.innerHTML;
    }

    stickyEl.addEventListener('click', (e) => {
      if (e.target.closest('[data-sticky-btn]')) {
        const haupt = mainBtn();
        if (haupt && !haupt.disabled) haupt.click();
      }
    });

    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', anstossen, { passive: true });

    const hotReload = document.querySelector('.vp-pdp-section product-hot-reload');
    if (hotReload) {
      new MutationObserver(() => {
        preisUebernehmen();
        anstossen();
      }).observe(hotReload, { childList: true });
    }
    anstossen();
  })();

  // Groessen-Sheet oeffnen/schliessen (gleiche Mechanik wie die MB-Artikelseite)
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-vp-open-guide]')) {
      var bd = document.querySelector('[data-vp-guide-backdrop]');
      if (bd) { bd.hidden = false; document.body.style.overflow = 'hidden'; }
    }
    if (e.target.closest('[data-vp-close-guide]') || e.target.hasAttribute('data-vp-guide-backdrop')) {
      var bd2 = document.querySelector('[data-vp-guide-backdrop]');
      if (bd2) { bd2.hidden = true; document.body.style.overflow = ''; }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
